import {autoinject} from "aurelia-dependency-injection";
import {AppEvents} from "../../app-events";

@autoinject
export class SizeManager {
    constructor(private appEvents: Backbone.Events) {
        this.setupSizeChecker();
    }

     /** Gets how many DocumentHolders can comfortably fit on screen */
    public get DesktopSlots(): number {
        const winWidth = $(window).width();
        if (winWidth < 1120) {
            return 1;
        } else if (winWidth < 1800) {
            return 2;
        } else {
            return 3;
        }
    }

     /** Gets the size of each desktop slot */
    public get DesktopSlotSize(): number {
        const slotCount = this.DesktopSlots;
        const size = ($(window).width() - 90) / slotCount;
        return size;
    }

    public calculateHeight(): number {
        return $(window).height() - 120;
    }

    private setupSizeChecker(): void {
        const self = this;
        $(window).resize(() => {
            self.appEvents.trigger(AppEvents.WindowResized, { width: $(window).width(), height: $(window).height() });
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/helpers/size-manager.ts